<div
  class="ml-1 pt-0 pr-0 pb-0"
  [iTooltipPlacement]="tooltipPosition"
  *transloco="let t"
  [iTooltip]="t('strategy-info-cell.ai-powered_targeting_is_deactivated')"
>
  <IIcon name="alertTriangle" class="warning" />
</div>
